import React, { useState } from 'react';

const ECodeStep = ({ onOTPLogin, onPasswordLogin, isLoading, error }) => {
  const [ecode, setEcode] = useState('');

  const handleOTPSubmit = async (e) => {
    e.preventDefault();
    if (!ecode.trim()) return;
    await onOTPLogin(ecode.trim());
  };

  const handlePasswordClick = () => {
    if (!ecode.trim()) return;
    onPasswordLogin(ecode.trim());
  };

  const isDisabled = !ecode.trim() || isLoading;

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Logo/Brand Area */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center mb-4">
            <img src="/images/logo.png" alt="MRC CRM Logo" className="w-50" />
          </div>
          <p className="text-gray-600">Sign in to your MRC CRM account</p>
        </div>

        {/* Login Form */}
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <form onSubmit={handleOTPSubmit} className="space-y-6">
            <div>
              <label htmlFor="ecode" className="block text-sm font-medium text-gray-700 mb-2">
                Employee Code
              </label>
              <div className="relative">
                <input
                  id="ecode"
                  type="text"
                  value={ecode}
                  onChange={(e) => setEcode(e.target.value.toUpperCase())}
                  placeholder="Enter your employee code"
                  required
                  disabled={isLoading}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors disabled:bg-gray-50 disabled:cursor-not-allowed text-lg"
                  autoComplete="username"
                  autoFocus
                />
                <div className="absolute inset-y-0 right-0 flex items-center pr-4">
                  <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
              </div>
            </div>

            {/* Error Message */}
            {error && (
              <div className="bg-red-50 border border-red-200 rounded-xl p-4">
                <div className="flex items-center">
                  <svg className="w-5 h-5 text-red-400 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <p className="text-red-800 text-sm">{error}</p>
                </div>
              </div>
            )}

            {/* Submit Buttons */}
            <div className="space-y-3">
              {/* Login with OTP */}
              <button
                type="submit"
                disabled={isDisabled}
                className="w-full bg-blue-600 text-white py-3 px-4 rounded-xl
                           font-medium hover:bg-blue-700
                           focus:outline-none focus:ring-2 focus:ring-blue-500
                           focus:ring-offset-2 transition-colors
                           disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isLoading ? 'Processing...' : 'Login with OTP'}
              </button>

              {/* Login with TransIT */}
              <button
                type="button"
                onClick={handlePasswordClick}
                disabled={isDisabled}
                className="w-full bg-gray-800 text-white py-3 px-4 rounded-xl
                           font-medium hover:bg-gray-900
                           focus:outline-none focus:ring-2 focus:ring-gray-500
                           focus:ring-offset-2 transition-colors
                           disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Login with TransIT
              </button>
            </div>
          </form>

          {/* Help Text */}
          
        </div>

        {/* Footer */}
        <div className="text-center mt-8">
          <p className="text-sm text-gray-500">
            © 2026 MRC CRM. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ECodeStep; 